import { DevicesSortField, DevicesSort, Device, DeviceSerialized } from '@playq/octopus2-devices';

import { IQuery } from '/common/models';

export enum IDeviceIcon {
  Unknown = 'UNKNOWN',
  Known = 'KNOWN',
  Cancel = 'CANCEL',
  Check = 'CHECK',
  Remove = 'REMOVE',
  Save = 'SAVE',
  Edit = 'EDIT',
  Subscribe = 'SUBSCRIBE',
  Unsubscribe = 'UNSUBSCRIBE',
}

export type DeviceQuery = IQuery<DevicesSortField, DevicesSort>;

export interface DeviceTableProps {
  setStoredDevice: (newValue: StorageDevice | null) => void;
  subscribeDevice: (value: SubscribeDevice) => void;
  changeSubscription: (deviceID: string, device: Device) => void;
  unsubscribe: (value: boolean) => void;
}
export type StorageDevice = { deviceID: string; device: DeviceSerialized };
export type SubscribeDevice = {
  deviceID: string;
  device: Device;
  reloadPage?: boolean;
};
